<div [class]='formConfig.formStyle'>
  <span class="material-icons-outlined dialog-close-icon" (click)='onNoClick()'>close</span>
  @if (!data.title) {
    <h1 mat-dialog-title>{{dialogTitle | translate}}</h1>
  }
  @if (data.title) {
    <h1 mat-dialog-title>{{data.title | translate | titlecase}}</h1>
  }
  <mat-dialog-content>
    @if (loading || datasetACS.loading.value) {
      <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
    }

    @if (datasetACS.actionConfig && !datasetACS.loading.value) {
      <div class='mb-24 full-form' [ngClass]='formConfig.formStyle'>
        <form-viewer #formViewer
          [record]='data.record'
          [dataContainerService]='datasetACS'
          [formConfig]='formConfig'
        ></form-viewer>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align='end'>
    <button class="close" mat-button (click)="onNoClick()">{{'Annulla' | translate}}</button>
    <button class='ml-4 save' mat-flat-button [disabled]='loading' color='accent' (click)="onSave()">{{'Salva' | translate}}</button>
  </mat-dialog-actions>
</div>
